import { mapState, mapActions } from 'vuex'

// 指定された配信タイプに属するお知らせタイプから選択するUIモジュール
export default {
  name: 'ServiceNoticeTypeSelectorButton',
  props: {
    name: {
      type: String,
      require: true
    },
    serviceId: {
      type: String,
      require: true
    },
    deliveryTypes: {
      type: Array,
      require: true,
    },
    index: {
      type: Number,
      require: false,
      default: 0
    },
    model: {
      type: Array,
      require: false,
      'default': () => []
    },
    disabled: {
      type: Boolean,
      require: false,
      'default': () => false
    }
  },
  data () {
    return {
      loading: true
    }
  },
  mounted () {
    // console.log('ServiceNoticeTypeSelectorButton | deliveryTypes', this.deliveryTypes)
    // console.log('ServiceNoticeTypeSelectorButton | model', this.model)
    this.init()
  },
  computed: {
    ...mapState({
      buttonId: state => state.selectServiceNoticeTypeModal.buttonId,
      value: state => state.selectServiceNoticeTypeModal.value,

      // model
      noticeTypeMstModel: state => state.selectServiceNoticeTypeModal.noticeTypeMstModel,
      serviceDeliveryTypeModel: state => state.selectServiceNoticeTypeModal.serviceDeliveryTypeModel,
    }),

    results () {
      if (this.loading) return ''

      // 設定されていたお知らせタイプが選択リストに存在しない場合、設定を削除する
      const checkValue = this.value
        .filter(noticeType => this.noticeTypeMstModel.findIndex(item => item.noticeType === noticeType) !== -1)
      this.setValue(checkValue)

      // お知らせタイプ名を取得
      try {
        return this.noticeTypeMstModel
          .filter(item => this.value.indexOf(item.noticeType) !== -1)
          .map(item => item.noticeTypeName).join('、')
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },

    // showDeleteButton () {
    //   return this.model ? true : false
    // }
  },
  watch: {
    model: function (to) {
      this.setValue(to)
    },
    value (to) {
      // 1画面に複数のモジュールが設置された場合の識別処理
      if (to && this.buttonId === this.name) {
        // console.log(this.name, to)
        this.changeValue(to)
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      loadModel: 'selectServiceNoticeTypeModal/loadModel',
      showModal: 'selectServiceNoticeTypeModal/show',
      setValue: 'selectServiceNoticeTypeModal/setValue'
    }),

    init () {
      // 初期データを格納
      this.setValue(this.model)

      // RSS取得のためデータ読出
      this.loading = true

      // データ読出し
      this.loadModel()
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    showSelector () {
      this.showModal({
        serviceId: this.serviceId,
        deliveryTypes: this.deliveryTypes,
        buttonId: this.name,
        data: this.value
      })
    },

    changeValue (data) {
      this.$emit('childs-change', {
        name: this.name,
        index: this.index,
        data: data
      })
    },
    // deleteScreen () {
    //   this.$emit('childs-delete', {
    //     name: this.name,
    //     index: this.index
    //   })
    // }
  }
}